import React, { useState, useEffect } from "react";
// import ChildPic from "../../../../assets/images/child-round.png";
import { useSelector, useDispatch } from "react-redux";
import useKidListFunctionality from "../../../customHooks/kidListHook";
// import useLangTranslation from "../../../customHooks/languageProvider";
import BoyAvtar from "../../../../assets/images/boy_avtar.svg";
import GirlAvtar from "../../../../assets/images/girl_avtar.svg";
import {
  setRulesDataApi,
  setRulesData as setRulesDataMethod,
  timeSupervision as timeSupervisionService,
} from "../../AxiosRtk/DashBoard";
import useSubscription from "../../../customHooks/subscriptionProvider";
import { useHistory } from "react-router-dom";
import useFirebase from "../../../../useFirebase";
// import useGetDeviceStatus from "../../../customHooks/getDeviceStatus";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import Select from "react-select";

const SetDailyLimitHeader = ({
  deviceId,
  setDeviceId,
  setRulesData,
  getLangTranslation,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { kidList, selectedKidId, kidDevicesList } = useSelector(
    ({ dashboard }) => dashboard
  );
  const [deviceOptions, setDeviceOptions] = useState([]);
  // const { setRulesData } = useSelector(({ setRules }) => setRules);

  const { postCollectionData } = useFirebase();

  // const { getDeviceStatus } = useGetDeviceStatus();
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  const kidData = kidList?.find((element) => element?.ID === selectedKidId);
  const { getImage } = useKidListFunctionality();
  // const selectedDeviceData = kidDevicesList?.find(
  //   (ele) => ele?.ID === deviceId
  // );
  const [timeSupervision, setTimeSupervision] = useState(false);
  const { checkSubsciption } = useSubscription();

  // console.log(timeSupervision)
  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  function timeSupervisionApi(timeSupervision) {
    const payload = {
      kidId: selectedKidId,
      deviceId,
      DailyLimit: setRulesData[0]?.daily_time_limit,
      dailyLimitSelectedDays: setRulesData[0]?.dailyLimitSelectedDays,
      IsWarnKidByAlertEnabled: setRulesData[0]?.is_warn_kid_by_alert_enabled,
      IsDeviceTimeSupervisionEnabled: timeSupervision,
      IsBlockWebAndAppEnabled: setRulesData[0]?.is_block_web_and_app_enabled,
      IsAllowAndMonitorParentsEnabled:
        setRulesData[0]?.is_allow_and_monitor_parents_enabled,
      dailyLimitSeekBarProgress: 0,
      AllowedApps: [],
      AllowedContacts: [],
    };

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      isDeviceTimeSupervisionEnabled: timeSupervision,
    };

    postCollectionData(deviceId, { timesupervison: collectionPayload });

    timeSupervisionService(payload)
      .then(() => {})
      .catch((err) => {
        console.log(
          "post time supervision catch error ==>>",
          err?.response?.data?.message
        );
      });
  }

  function handleDeviceTimeSupervisionBtn(e) {
    if (!checkSubsciption()) {
      return;
    }
    const { checked } = e.target;
    setTimeSupervision(checked ? 1 : 0);
    timeSupervisionApi(checked ? 1 : 0);
  }

  useEffect(() => {
    // console.log(setRulesData)
    if (setRulesData) {
      setTimeSupervision(
        setRulesData?.timesupervison?.isDeviceTimeSupervisionEnabled
      );
    } else {
      setTimeSupervision(false);
    }
  }, [setRulesData]);

  useEffect(() => {
    if (deviceId) {
      getDeviceStatusData(deviceId);
    }
  }, [deviceId]);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  return (
    <div className="card mb-6">
      <div className="card-body">
        <div className="inline-list-wrap separator space-24">
          <div className="list-item">
            <div className="list-content d-flex">
              {/* <Link to="/" className="text-blue-900 fs-5"> */}
              <i
                className={` mt-1 fs-5 fw-700 c-pointer ${
                  lang?.isRTL === 1 ? "icon-arrow-right" : "icon-arrow-left"
                }`}
                onClick={() => history.goBack()}
              />
              {/* </Link> */}
              <h3 className="text-blue-900 mb-0">
                {getLangTranslation(
                  "EXTRA_TIME_REQUEST_DAILY_LIMIT",
                  "Daily Limit"
                )}
              </h3>
            </div>
          </div>
          <div className="list-item">
            <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
              {/* <img src={ChildPic} alt='' /> */}
              <img
                src={getImage(kidData?.image, kidData?.gender)}
                alt=""
                className="img-fluid rounded-circle"
                onError={(event) => {
                  event.target.onerror = null;
                  event.target.src = getImage("", kidData?.gender);
                }}
              />
            </span>
            <div className="list-content">
              <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
              <CommonStatus status={deviceStatus} />
            </div>
          </div>
          <div className="list-item content-300 w-100">
            <div className="select-with-icon">
              <span className="icon-wrap icon-blue pt-cursor border-0">
                <i className="icon-mobile fs-5" />
              </span>
              {/*  <select
                className="form-select  text-dark single-select-text"
                onChange={(e) => setDeviceId(e.target.value)}
                value={deviceId}
              >
                <option value="">Select</option>
                {kidDevicesList?.map((item) => {
                  return (
                    <option value={item?.ID} key={item?.ID}>
                      {item?.Name}
                    </option>
                  );
                })}
              </select>*/}
              <Select
                className="custom-select "
                classNamePrefix="custom-select"
                placeholder="Select Device"
                options={deviceOptions}
                value={
                  deviceOptions?.find((item) => item?.value == deviceId) || ""
                }
                onChange={(val) => {
                  setDeviceId(val.value);
                }}
                isSearchable={false}
              />
            </div>
          </div>
          <div
            className={`form-check form-check-right form-switch align-self-center mb-0 c-pointer ${
              lang?.isRTL === 1 ? "me-auto" : "ms-auto"
            }`}
          >
            <input
              className="form-check-input c-pointer"
              type="checkbox"
              role="switch"
              id="deviceTime"
              onChange={handleDeviceTimeSupervisionBtn}
              checked={!!timeSupervision}
            />
            <label
              className="form-check-label c-pointer text-blue-800 fw-semibold"
              htmlFor="deviceTime"
            >
              {getLangTranslation(
                "SET_DAILY_TIME_LOCK_THE_DEVICE_AFTER_THE_LIMIT",
                "Lock the device after the limit"
              )}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetDailyLimitHeader;
